import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';

export const LabelText = styled(Typo).attrs({
  type: 'label3',
  weight: 'm',
})`
  color: ${(props) => props.theme.colors.gray700};
  width: 72px;
  padding: 4px 0px;
`;

export const MainLabelText = styled(Typo).attrs({
  type: 'label2',
  weight: 'sb',
})`
  color: ${(props) => props.theme.colors.gray800};
  width: 72px;
`;

export const LabelRow = styled(Flex)`
  gap: 16px;
  align-items: flex-start;
`;

export const FilterItemWrapper = styled(Flex)`
  background-color: ${(props) => props.theme.colors.gray200};
  padding: 4px 8px;
  gap: 10px;
  border-radius: ${(props) => props.theme.radius.token['3xl']}px;
`;
